import React from 'react';

export const NoHobby = ({ label }) => {
    
    return (
        <p style={{padding: '1em', border: '1px solid', borderRadius: '4px', backgroundColor: '#ebebeb'}}>{label}</p>
    );
};